/**
 * Staff roles (users.role). Patients are role 2 and never sign in to this panel.
 * The numbers are the server's: they are NOT in display order.
 */
export const DOCTOR = 1;

/** The old name for DOCTOR (role 1 was "clinical admin" before the three-role split). */
export const CLINICAL_ADMIN = DOCTOR;

export const SUPER_ADMIN = 3;

/** Doctor powers, sees every patient (never narrowed to their own). Section access 'all' opens a section to Admins too. */
export const ADMIN = 4;

/** How the roles are shown, e.g. in the header search, in appointment history and on Staff activity. */
export const ROLE_LABELS = {
    [DOCTOR]: "Doctor",
    [ADMIN]: "Admin",
    [SUPER_ADMIN]: "Super admin",
};

/** Every role that signs in to this panel: Doctors (1), Admins (4) and super admins (3). Patients are role 2. */
export const STAFF_ROLES = [DOCTOR, ADMIN, SUPER_ADMIN];

/** Whether this role is a staff role (Doctor, Admin or Super admin) - never true for a patient or anything else. */
export function isStaffRole(role) {
    return STAFF_ROLES.includes(role);
}
